var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "dialogText",
        "max-width": "500",
        persistent: "",
        light: "",
      },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c("v-card", [
            _c(
              "div",
              {},
              [
                _c("div", { staticClass: "pb-2" }),
                _vm.$store.getters.deviceClass.includes("xs")
                  ? _c(
                      "v-card-title",
                      { staticClass: "headline text-center darkColor d-block" },
                      [_vm._v(" Datenschutz-einstellungen ")]
                    )
                  : _c(
                      "v-card-title",
                      { staticClass: "headline text-center d-block darkColor" },
                      [_vm._v("Datenschutzeinstellungen")]
                    ),
                _c("v-card-text", [
                  _c(
                    "div",
                    { staticClass: "text-center dsgvo" },
                    [
                      _c(
                        "p",
                        { staticClass: "text-left" },
                        [
                          _vm._v(
                            "Wir verwenden Cookies, um Dir ein schnelles und personalisiertes Erlebnis zu bieten. Details zu den verwendeten Cookies und unseren Partnern findest Du "
                          ),
                          _c(
                            "router-link",
                            {
                              attrs: { to: { name: "Cookies" } },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.closeDialog.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("hier")]
                          ),
                          _vm._v(" . "),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass:
                            "bigger-input align-center justify-space-between",
                        },
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-checkbox", {
                                staticClass: "d-inline-block",
                                attrs: { disabled: true, label: "Notwendig" },
                                model: {
                                  value: _vm.notwendig,
                                  callback: function ($$v) {
                                    _vm.notwendig = $$v
                                  },
                                  expression: "notwendig",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-checkbox", {
                                staticClass: "d-inline-block",
                                attrs: { label: "Statistiken" },
                                model: {
                                  value: _vm.statistics,
                                  callback: function ($$v) {
                                    _vm.statistics = $$v
                                  },
                                  expression: "statistics",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "pa-1" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "okBtn btn-df text-none",
                              attrs: { rounded: "" },
                              nativeOn: {
                                "&click": function ($event) {
                                  $event.stopPropagation()
                                  return _vm.clickOk.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v(" Einverstanden ")]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "spacer-25" }),
                      _c("div", { staticClass: "pt-2" }, [
                        _vm._v("Deine Einwilligung ist jederzeit widerrufbar."),
                      ]),
                      _c(
                        "div",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: { to: { name: "Cookies" } },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.closeDialog.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("Cookie-Details ")]
                          ),
                          _vm._v(" | "),
                          _c(
                            "router-link",
                            {
                              attrs: { to: { name: "Datenschutz" } },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.closeDialog.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("Datenschutzerklärung ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "pb-2" }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }